// External
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

// Internal
import { HomeRoutingModule } from './home.routes';
import { HomeComponent } from './home.component';
import { SharedModule } from '../../common/components/shared.module';
import { DirectivesModule } from '../../common/components/directives.module';
import { UiAlertModule } from '../../common/components/ui/ui-alert/ui-alert.module';
import { UiIconModule } from '../../common/components/ui/ui-icon/ui-icon.module';
import { UiLogoModule } from '../../common/components/ui/ui-logo/ui-logo.module';
import { UiCardModule } from '../../common/components/ui/ui-card/ui-card.module';

@NgModule({
    declarations: [ HomeComponent ],
    imports: [
        HomeRoutingModule,
        SharedModule,
        TranslateModule,
        DirectivesModule,
        UiAlertModule,
        UiIconModule,
        UiCardModule,
        UiLogoModule
    ],
    exports: [ HomeComponent ]
})

export class HomeModule {}
